import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoorOpenFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M13 28H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7v2H6v20h7zM27 3.8 16 1.2a1 1 0 0 0-.2 0 .8.8 0 0 0-.8.8v28a.8.8 0 0 0 .8.8 1 1 0 0 0 .2 0l11-2.6a1.3 1.3 0 0 0 1-1.2V5a1.3 1.3 0 0 0-1-1.2M20 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1" /></svg>;
const ForwardRef = forwardRef(IconDoorOpenFilledSVG);
ForwardRef.displayName = "IconDoorOpenFilled";
export { ForwardRef as IconDoorOpenFilled };